module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/time-e5c1f9eb4ae20ff245778c90a8b03ae2.svg";